import { LayoutHeaderMenuDropdownItem } from "../../../../types";
import { Text } from "../../../ui/text";
import { headerMenuItemFeatured } from "./header-menu.variants";
import NextLink from "next/link";
import { slugify } from "../../../../util/text";
import { EventAction } from "../../../../config/events";
import { Button } from "../../../ui/button";

type HeaderMenuItemFeaturedProps = {
  theme: "dark" | "light";
  item: LayoutHeaderMenuDropdownItem;
};

function HeaderMenuItemFeatured({ theme, item }: HeaderMenuItemFeaturedProps) {
  const { title, description, label, link, openNewWindow } = item;

  const styles = headerMenuItemFeatured({ theme });
  const slugifiedSectionName = slugify(`header_${title}`);

  return (
    <div className={styles.base()}>
      <header className={styles.header()}>
        <Text size="body" weight="semibold" className={styles.title()}>
          {title}
        </Text>
        <Text size="tinyBody" weight="medium" className={styles.description()}>
          {description}
        </Text>
      </header>

      <Button
        size="sm"
        appearance="link"
        color={"blueLight"}
        href={link}
        sectionName={`${slugifiedSectionName}_${title}`}
        endIcon={"arrow-right"}
        title={label}
      >
        {label}
      </Button>
    </div>
  );
}

export default HeaderMenuItemFeatured;
